<div class="footer-container">
    <div class="footer-order row">
        <div class="footer-links col-12 col-md-10">
          <a href="{{privacyPolicyLink}}" class="privacy-policy-link" target="_blank">Privacy & Security Policy</a>
          <span> | </span>
          <a href="{{termsOfUseLink}}" class="terms-of-use-link" target="_blank">Terms of Use</a>
          <span *ngIf="programFactsLink != null"> | </span>
          <a *ngIf="programFactsLink != null" href="{{programFactsLink}}" class="program-facts-link" target="_blank">Important Program Facts</a>
          <span *ngIf="oneTrustWebformLink != null"> | </span>
          <a *ngIf="oneTrustWebformLink != null" href="{{oneTrustWebformLink}}" class="one-trust-webform-link" target="_blank">
            Do Not Sell or Share My Personal Information
          </a>
        </div>
        <div class="footer-logo col-12 col-md-2">
            <img class="norton-logo" src="../assets/norton_logo.svg" />
        </div>
        <div class="footer-content col-12">
            <p>Invitations for application for life insurance on this site are made through Efinancial, LLC, a life
                insurance agency, or through its designated agent, Michael
                Bowcock, only where licensed and appointed. License numbers are available upon request and are
                automatically
                provided where required by law. Michael
                Bowcock is a licensed life insurance agent in all 50 states, including the District of Columbia, and his
                resident state of Illinois. Michael Bowcock’s Illinois license
                number is 11736943; in California, 0G99555; in Louisiana, 589562; in Minnesota, 40333060; in Utah,
                445133;
                in Massachusetts, 1884080; and in Texas, 1617308.
                Efinancial, LLC’s California license number (d/b/a Efinancial Term Insurance Services) is 0F37537; in
                Louisiana, 323680 and in Utah, 104501.</p>
            <p>Insurers: American General Life and Accident Insurance Company, Nashville, TN; Banner Life Insurance
                Company,
                Frederick, MD, and William Penn Life
                Insurance Company, Garden City, NY, both Legal & General America companies; Fidelity Life Association, A
                Legal Reserve Life Insurance Company, Chicago, IL;
                North American Company, Sioux Falls, SD; Protective Life and Annuity, Birmingham, AL; Pruco Life
                Insurance
                Company, Newark, NJ and Pruco Life Insurance
                Company of New Jersey, Newark, NJ, member companies of Prudential Financial, Inc., Newark, NJ;
                Transamerica
                Financial Life Insurance Company, Harrison, NY,
                and Transamerica Life Insurance Company, Cedar Rapids, IA, both AEGON companies.</p>
            <p>Products, rates and time required to purchase a policy vary by insurer.</p>
        </div>

    </div>

</div>
